// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skill-item[data-v-3486c734]{width:100%;display:flex;justify-content:space-between;align-items:center;padding:.75rem 2rem;border-top:1px solid #d8d8d8;cursor:pointer;background-color:#fff}.skill-item p.skill-item__title[data-v-3486c734]{padding:0;text-align:left;margin:0 1rem 0 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
